import api, { transformResponse } from "services/api";

export const creditorAgencySettingsApi = api
  .enhanceEndpoints({ addTagTypes: ["Agency"] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchCreditorAgency: build.query({
        query: () => `/api/v1/creditor/agency-settings/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (result) =>
          result
            ? // successful query
              [
                { type: "Agency", id: result.id },
                { type: "Agency", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'Agency', id: 'LIST' }` is invalidated
              [{ type: "Agency", id: "LIST" }],
      }),
    }),
  });

export const { useFetchCreditorAgencyQuery } = creditorAgencySettingsApi;
